import React from 'react';
import Input from './Input.jsx';

export default class TextInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      inputProps: props
    };
  }

  handleChange(field) {
    const props = this.props;
    const correct = props.forbiddenChars ?
    !field.value.match(new RegExp('[' + props.forbiddenChars + ']')) : true;
    if (props.onChange && correct) {
      const inputProps = {...this.state.inputProps, value: field.value};
      this.setState({inputProps});
      props.onChange({name: field.name, value: field.value});
    }
  }

  render() {
    return (
      <Input {...this.props} onChange={this.handleChange.bind(this)} />
    );
  }
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/TextInput.jsx